<h1 mat-dialog-title>Benutzer wechseln</h1>
<div mat-dialog-content>
  <mat-form-field style="width: 100%">
    <mat-label>Benutzer ausw&auml;hlen</mat-label>
    <mat-select [formControl]="userCtrl" (selectionChange)="selectionChanged($event)">
      @for (u of users; track u) {
        <mat-option [value]="u">{{ u.firstName }} {{ u.lastName }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="accent" (click)="resetUser()">Zu eigenem Benutzer wechseln</button>
</div>
